import React, { useState } from 'react'
import ContactMailIcon from '@material-ui/icons/ContactMail'
import Card from '@auteco/components/sharedComponents/Card/Card'
import CardBody from '@auteco/components/sharedComponents/Card/CardBody'
import CardFooter from '@auteco/components/sharedComponents/Card/CardFooter'
import CardIcon from '@auteco/components/sharedComponents/Card/CardIcon'
import CustomInput from '@auteco/components/sharedComponents/CustomInput/CustomInput'
import Button from '@auteco/components/sharedComponents/CustomButtons/Button'
import { CardHeader, Typography } from '@material-ui/core'


const PqrsFinder = ({ getPqrsDoc }) => {
    const [documentInput, setDocumentInput] = useState('')
    const [isInvalid, setIsInvalid] = useState(false)

    const onChange = (e) => {
        setDocumentInput(e.target.value)
        if (e.target.value === '') {
            setIsInvalid(false)
        } else {
            const isInvalidInput = !/^\d+$/.test(e.target.value)
            setIsInvalid(isInvalidInput)
        }
    }

    const onSearch = () => {
        getPqrsDoc({ doc: documentInput })
    }

    return (
        <Card>
            <CardHeader color="customAuteco" stats icon>
                <CardIcon color="customAuteco">
                    <ContactMailIcon />
                </CardIcon>
            </CardHeader>
            <CardBody>
                <CustomInput
                    labelText='Busque por cédula'
                    id="cedula"
                    value={documentInput}
                    required
                    formControlProps={{
                        fullWidth: true,
                        required: true,
                    }}
                    inputProps={{
                        onChange,
                        autoComplete: 'on',
                    }}
                    helperText={{}}
                />
                {isInvalid && <Typography style={{ color: 'red', fontSize: 12 }}>Documento inválido</Typography>}
            </CardBody>
            <CardFooter>
                <Button
                    color="warning"
                    disabled={isInvalid}
                    onClick={onSearch}
                >
                    Buscar
                </Button>
            </CardFooter>
        </Card>
    )
}

export { PqrsFinder }
